const url = {
  dev: 'dev-back-office.rematch.tv',
  preprod: 'preprod-back-office.rematch.tv',
  prod: 'back-office.rematch.tv'
}

let env = null

if (window.location.hostname === url.dev) {
  env = 'dev'
} else if (window.location.hostname === url.preprod) {
  env = 'preprod'
} else if (window.location.hostname === url.prod) {
  env = 'prod'
} else {
  console.error('Invalid environment url => moving to prod')
  env = 'prod'
}

console.log('Current environment: ', env)
export default env



// WEBPACK FOOTER //
// ./src/tools/env.js